var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 14.0003C26.4168 6.64033 20.6302 0.666992 13.5002 0.666992C6.37016 0.666992 0.583496 6.64033 0.583496 14.0003C0.583496 20.4537 5.02683 25.827 10.9168 27.067V18.0003H8.3335V14.0003H10.9168V10.667C10.9168 8.09366 12.9447 6.00033 15.4377 6.00033H18.6668V10.0003H16.0835C15.3731 10.0003 14.7918 10.6003 14.7918 11.3337V14.0003H18.6668V18.0003H14.7918V27.267C21.3147 26.6003 26.4168 20.9203 26.4168 14.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).262c650d96d0e7206442e956225d8181.svg";
export { ForwardRef as ReactComponent };